exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "/* Shadows are intentionally very subtle gradiations. */\n.Label-Label_qMY_2 {\n  display: -ms-inline-flexbox;\n  display: inline-flex;\n  margin-bottom: 0.25rem; }\n", "", {"version":3,"sources":["/opt/atlassian/pipelines/agent/build/src/components/Form/Label/Label.scss"],"names":[],"mappings":"AAAA,wDAAwD;AACxD;EACE,4BAA4B;EAC5B,qBAAqB;EACrB,uBAAuB,EAAE","file":"Label.scss","sourcesContent":["/* Shadows are intentionally very subtle gradiations. */\n.Label {\n  display: -ms-inline-flexbox;\n  display: inline-flex;\n  margin-bottom: 0.25rem; }\n"],"sourceRoot":""}]);

// exports
exports.locals = {
	"Label": "Label-Label_qMY_2"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"sourceMap":true,"importLoaders":1,"localIdentName":"[name]-[local]_[hash:base64:5]"}!./node_modules/postcss-loader/lib?{"ident":"postcss"}!./node_modules/sass-loader/lib/loader.js!./node_modules/sass-resources-loader/lib/loader.js?{"resources":["./src/assets/scss/base.scss","./src/assets/scss/helpers.scss"]}!./src/components/Form/Label/Label.scss
// module id = 1290
// module chunks = 0